<script setup lang="ts">
import IdleWarningModal from '~/components/utils/IdleWarningModal.vue'
import { useIdleDetection } from '~/composables/useIdleDetection'

useIdleDetection()
</script>

<template>
  <RouterView />
  <IdleWarningModal />
</template>
